import Error from '../model/Error';
import SectionClubRelation from '../dto/SectionClubRelation';
import axios from 'axios';
import moment from 'moment';

export default class SectionClubRelationRepository {

    static findAll(clubId) {
        return new Promise((resolve, reject) => {
            axios
                .get('/clubs/' + clubId + '/section-relations')
                .then(response => resolve(response.data.data.map(data => SectionClubRelation.fromData(data))))
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static create(clubId, sectionId, start, end) {
        return new Promise((resolve, reject) => {
            axios
                .post('/section-club-relations', {
                    clubId,
                    sectionId,
                    start: moment(start, 'DD.MM.YYYY').format('YYYY-MM-DD'),
                    end: end ? moment(end, 'DD.MM.YYYY').format('YYYY-MM-DD') : null,
                })
                .then(() => resolve())
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static remove(relationId) {
        return new Promise((resolve, reject) => {
            axios
                .delete('/section-club-relations/' + relationId)
                .then(() => resolve())
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static update(relations) {
        return Promise.all(relations.map(relation => {
            return new Promise((resolve, reject) => {
                axios
                    .put('/section-club-relations/' + relation.id, {
                        start: moment(relation.start, 'DD.MM.YYYY').format('YYYY-MM-DD'),
                        end: relation.end ? moment(relation.end, 'DD.MM.YYYY').format('YYYY-MM-DD') : null,
                    })
                    .then(() => resolve())
                    .catch(error => reject(Error.fromResponse(error.response)));
            });
        }));
    }
}
